import {
  DEFAULT_COUNTRY_CODE,
  DEFAULT_CURRENCY_CODE,
} from 'lib/constants/siteDefaults';

import { roundUpToNearestHalf } from './roundUpToNearestHalf';
import { roundUpToTwoDecimals } from './roundUpToTwoDecimals';

const defaultOptions = {
  isoCode: DEFAULT_COUNTRY_CODE,
  currency: DEFAULT_CURRENCY_CODE,
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
  isCurrencyCodeHidden: false,
};

/*
 * This has been created specifically for the component <FormatPrice />
 * and is not intended for use elsewhere as the formatting occurs in both
 * this util and the FormatPrice component
 */
export const formatPriceParts = (
  price: number,
  shouldRoundUp?: boolean,
  options: {
    isoCode?: string;
    currency?: string;
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
    isCurrencyCodeHidden?: boolean;
  } = defaultOptions,
) => {
  const isCanada = options.isoCode === 'CA';
  const isSwitzerland = options.isoCode === 'CH';

  const roundedPrice = shouldRoundUp
    ? roundUpToNearestHalf(price)
    : roundUpToTwoDecimals(price);

  const isPriceDecimal = roundedPrice % 1 !== 0;

  const formatter = new Intl.NumberFormat(
    `en-${options?.isoCode || DEFAULT_COUNTRY_CODE}`,
    {
      style: 'currency',
      currency: options.currency || defaultOptions.currency,
      minimumFractionDigits:
        options.minimumFractionDigits || isPriceDecimal
          ? 2
          : defaultOptions.minimumFractionDigits,
      maximumFractionDigits:
        options.maximumFractionDigits || defaultOptions.maximumFractionDigits,
    },
  );

  const parts = formatter.formatToParts(roundedPrice);

  const currencyParts: Intl.NumberFormatPart[] = [];
  const integerParts: Intl.NumberFormatPart[] = [];
  const fractionalParts: Intl.NumberFormatPart[] = [];

  let decimalFound = false;

  parts.forEach((element) => {
    if (element.type === 'decimal' || element.type === 'fraction') {
      decimalFound = true;
    }

    if (element.type === 'currency') {
      currencyParts.push(element);
    }

    if (element.type === 'integer' || element.type === 'group') {
      integerParts.push(element);
    }

    if (decimalFound) {
      fractionalParts.push(element);
    }
  });

  return (
    <>
      {currencyParts.map((part) => part.value)}
      {isSwitzerland && ' '}
      {integerParts.map((part) => part.value)}
      {!!fractionalParts.length && (
        <span className="decimal">
          {fractionalParts.map((part) => part.value)}
        </span>
      )}
      {isCanada && !options.isCurrencyCodeHidden && ` ${options.currency}`}
    </>
  );
};
